import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bfe235ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Plan-container" }
const _hoisted_2 = { class: "container-fluid px-0" }
const _hoisted_3 = { class: "Plan-padding" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "План")
], -1))
const _hoisted_6 = { class: "col-4 Plan-stateDesc" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Plan-switchText" }, "Скрыть настройки", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Plan-switchIcon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-up" })
], -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Plan-switchText" }, "Показать настройки", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Plan-switchIcon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-down" })
], -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = { class: "card Plan-mainSettings" }
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-4" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Основное", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1))
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-6" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Дата создания", -1))
const _hoisted_27 = { class: "col-6" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Дата расчета", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Использовать", -1))
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "col-4" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Дополнительные ограничения", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Высота перекрытия ярусов (мм) ", -1))
const _hoisted_34 = { class: "col-4" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Данные", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "dx-button-text" }, "Импорт")
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "dx-button-text" }, "Экспорт")
], -1))
const _hoisted_38 = {
  key: 0,
  class: "Changes-warning"
}
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-12" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dx-button-text" }, "Сохранить", -1))
const _hoisted_42 = { class: "col-12" }
const _hoisted_43 = { class: "card border-0" }
const _hoisted_44 = {
  class: "card-body",
  style: {"padding":"0 0 10px 0"}
}
const _hoisted_45 = { class: "d-flex align-items-center" }
const _hoisted_46 = { class: "d-inline-block" }
const _hoisted_47 = { class: "dx-button-text" }
const _hoisted_48 = {
  key: 0,
  class: "d-inline-block Plan-progressBarWrapper px-2"
}
const _hoisted_49 = { class: "progress" }
const _hoisted_50 = {
  class: "progress-bar progress-bar-striped progress-bar-animated",
  role: "progressbar",
  "aria-valuenow": "100",
  "aria-valuemin": "0",
  "aria-valuemax": "100",
  style: {"width":"100%","background-color":"#363b5d !important"}
}
const _hoisted_51 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_DateControl = _resolveComponent("DateControl")!
  const _component_EnumControl = _resolveComponent("EnumControl")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_DxTabPanel = _resolveComponent("DxTabPanel")!
  const _component_ImportAllWorkflow = _resolveComponent("ImportAllWorkflow")!
  const _component_ExportAllWorkflow = _resolveComponent("ExportAllWorkflow")!
  const _component_PlanInnerInfoDialog = _resolveComponent("PlanInnerInfoDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, _toDisplayString(_ctx.stateDescription), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_DxButton, {
              class: "float-end",
              width: 36,
              type: "normal",
              icon: "info",
              hint: "Справка",
              "styling-mode": "contained",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onShowInfo()))
            })
          ])
        ]),
        _createElementVNode("div", {
          class: "Plan-switch",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSwitchChange && _ctx.onSwitchChange(...args))),
          "data-bs-toggle": "collapse",
          "data-bs-target": ".multi-collapse",
          "aria-expanded": "false",
          "aria-controls": "collapse1"
        }, [
          (_ctx.isSettingsOpen.shown)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", {
              class: _normalizeClass(["collapse multi-collapse", _ctx.showClass]),
              id: "collapse1"
            }, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _hoisted_23,
                      _createVNode(_component_TextControl, {
                        class: "ModelField-control",
                        stylingMode: "outlined",
                        placeholder: "Наименование...",
                        "show-clear-button": true,
                        value: _ctx.model.name,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.name) = $event)),
                        hasEmptyValue: false,
                        valueChangeEvent: "keyup",
                        onChanged: _ctx.haveChanges
                      }, null, 8, ["value", "onChanged"]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createVNode(_component_DateControl, {
                            class: "ModelField-control",
                            value: _ctx.model.creationDate,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.creationDate) = $event)),
                            mode: "datetime",
                            stylingMode: "outlined",
                            hasEmptyValue: false,
                            readOnly: true,
                            onChanged: _ctx.haveChanges
                          }, null, 8, ["value", "onChanged"])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _createVNode(_component_DateControl, {
                            class: "ModelField-control",
                            value: _ctx.model.calcCompletedDate,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.calcCompletedDate) = $event)),
                            mode: "datetime",
                            stylingMode: "outlined",
                            hasEmptyValue: false,
                            readOnly: true,
                            onChanged: _ctx.haveChanges
                          }, null, 8, ["value", "onChanged"])
                        ])
                      ]),
                      _hoisted_29,
                      _createVNode(_component_EnumControl, {
                        class: "ModelField-control",
                        id: _ctx.model.optFunction,
                        "onUpdate:id": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.optFunction) = $event)),
                        desc: _ctx.model.optFunctionDescription,
                        "onUpdate:desc": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.optFunctionDescription) = $event)),
                        enumType: "optFunctionType",
                        stylingMode: "outlined",
                        onChanged: _ctx.haveChanges
                      }, null, 8, ["id", "desc", "onChanged"]),
                      (!_ctx.isCalculation)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, " Время последнего расчета — " + _toDisplayString(_ctx.seconds == 0 ? '1 сек' : _ctx.calculationTime) + ". ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("div", null, [
                        _hoisted_33,
                        _createVNode(_component_IntegerControl, {
                          class: "col-6 ModelField-control",
                          stylingMode: "outlined",
                          placeholder: "Высота перекрытия ярусов...",
                          value: _ctx.model.overlapTiersHeight,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.overlapTiersHeight) = $event)),
                          hasEmptyValue: true,
                          min: 0,
                          valueChangeEvent: "keyup",
                          onChanged: _ctx.haveChanges
                        }, null, 8, ["value", "onChanged"])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_DxCheckBox, {
                          class: "Plan-checkbox",
                          value: _ctx.model.isMixedLoading,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.isMixedLoading) = $event)),
                          text: "Смешанная погрузка рулонов большого формата",
                          onValueChanged: _ctx.haveChanges
                        }, null, 8, ["value", "onValueChanged"])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_DxCheckBox, {
                          class: "Plan-checkbox",
                          value: 
                            _ctx.model.isAlternateFormatsToOverlapVerticalSeam
                          ,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((
                            _ctx.model.isAlternateFormatsToOverlapVerticalSeam
                          ) = $event)),
                          text: "Чередовать форматы в соседних столбцах для перекрытия вертикального стыка",
                          onValueChanged: _ctx.haveChanges
                        }, null, 8, ["value", "onValueChanged"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createElementVNode("div", null, [
                        _createVNode(_component_DxButton, {
                          disabled: !_ctx.model.id,
                          class: "Plan-importButton",
                          type: "default",
                          onClick: _ctx.onImport,
                          "styling-mode": "outlined"
                        }, {
                          content: _withCtx(() => [
                            _hoisted_36
                          ]),
                          _: 1
                        }, 8, ["disabled", "onClick"]),
                        _createVNode(_component_DxButton, {
                          disabled: !_ctx.model.id,
                          class: "Plan-exportButton",
                          style: {"margin-left":"10px"},
                          type: "default",
                          onClick: _ctx.onExport,
                          "styling-mode": "outlined"
                        }, {
                          content: _withCtx(() => [
                            _hoisted_37
                          ]),
                          _: 1
                        }, 8, ["disabled", "onClick"])
                      ])
                    ])
                  ]),
                  (_ctx.hasSettingsChanges)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, " Изменения вступят в силу после сохранения "))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createVNode(_component_DxButton, {
                        class: "Plan-saveButton",
                        type: "default",
                        disabled: _ctx.isCalculation,
                        onClick: _ctx.onSave,
                        "styling-mode": "outlined"
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("span", null, [
                            (_ctx.saving)
                              ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                                  key: 0,
                                  icon: "circle-notch",
                                  spin: ""
                                }))
                              : _createCommentVNode("", true),
                            _hoisted_41
                          ])
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"])
                    ])
                  ])
                ])
              ])
            ], 2)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["row", { 'Plan-progressBarSticked': _ctx.isCalculation }])
        }, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createVNode(_component_DxButton, {
                      class: "Plan-calcButton",
                      type: "default",
                      "styling-mode": "outlined",
                      disabled: _ctx.calcButtonDisabled,
                      onClick: _ctx.onCalcButtonClick
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("span", null, [
                          (_ctx.calculationStarting || _ctx.calculationStopping)
                            ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                                key: 0,
                                icon: "circle-notch",
                                spin: ""
                              }))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.calcButtonText), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ]),
                  (_ctx.isCalculation)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, " Расчет - " + _toDisplayString(_ctx.calculationTime), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ], 2)
      ]),
      _createVNode(_component_DxTabPanel, {
        class: "Plan-panel",
        key: _ctx.tabsRenderKey,
        height: "100%",
        "data-source": _ctx.tabs,
        "selected-index": _ctx.selectedTabIndex,
        "onUpdate:selected-index": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedTabIndex) = $event)),
        loop: false,
        "animation-enabled": false,
        "swipe-enabled": false
      }, {
        title: _withCtx(({ data: tab }) => [
          _createElementVNode("span", null, _toDisplayString(tab.name), 1)
        ]),
        item: _withCtx(({ data: tab }) => [
          _createElementVNode("div", {
            id: tab.domId,
            class: "catalogue-panel"
          }, null, 8, _hoisted_51)
        ]),
        _: 1
      }, 8, ["data-source", "selected-index"])
    ]),
    _createVNode(_component_ImportAllWorkflow, {
      controller: "Plan",
      importConfig: _ctx.importConfig,
      planId: _ctx.model.id,
      onImportExportClose: _ctx.onImportExportClose,
      ref: "importWorkflow"
    }, null, 8, ["importConfig", "planId", "onImportExportClose"]),
    _createVNode(_component_ExportAllWorkflow, {
      controller: "Plan",
      exportConfig: _ctx.exportConfig,
      ref: "exportWorkflow"
    }, null, 8, ["exportConfig"]),
    _createVNode(_component_PlanInnerInfoDialog, { ref: "infoDialog" }, null, 512)
  ]))
}